import React, { useRef, useState, useEffect } from "react";
import { RiExpandUpDownLine } from "react-icons/ri";
import { LinearProgress, Box, Button, Grid, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, Tab, Tabs, Autocomplete, TextField, Typography, Dialog, DialogActions, DialogContent, DialogTitle, Tooltip } from "@mui/material";
import useAuth from "../context/AuthProvider";
import { DataGridPro, GridColDef, GridRowId, GridSelectionModel, GridSortModel } from "@mui/x-data-grid-pro";
import { getRowsPerPageOptions } from "../components/AddEdit/CustomFunctions";
import { apiClient } from "../helper/api";
import { formatUtcToLocal } from "../helper/utils";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import { Close, KeyboardArrowUp, Search, KeyboardArrowDown, FileDownload, Refresh } from "@mui/icons-material";
// @ts-ignore
import html2pdf from "html2pdf.js";
import moment from "moment";
import { canMarkMiscNonPremiumComplete, isSuperAdminRole } from "../helper/userRoles";

const REJECTION_NOTE_MAX_LENGTH = 1000;

interface NonPremiumEndorsementModel {
  id?: number;
  nonPremiumEndorsementId?: number;
  client?: string;
  customerName?: string;
  state?: string;
  filingState?: string;
  homeState?: string;
  document?: string;
  documentName?: string;
  blobAddress?: string;
  dateReceived?: string;
  dateRecived?: string;
  dateCompleted?: string;
  rejectedAt?: string;
  rejectionNote?: string;
  rejectedByUserId?: number;
  status?: string;
}

interface NonPremiumEndorsementModel_Resp {
  getNonPremiumEndorsement_Respdata: NonPremiumEndorsementModel[];
  totalCount: number;
}

interface Iprops {
  ReportModuleCL: NonPremiumEndorsementModel_Resp;
  setSelectedRows: React.Dispatch<React.SetStateAction<NonPremiumEndorsementModel[] | null>>
  selectedRows: NonPremiumEndorsementModel[] | null
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>
  setPageSize: React.Dispatch<React.SetStateAction<number>>
  _pageSize: number
  filterModel: { items: { columnField: string, value: string, operatorValue: string }[], logicOperator?: 'and' | 'or' }
  setFilterModel: React.Dispatch<React.SetStateAction<{ items: { columnField: string, value: string, operatorValue: string }[], logicOperator?: 'and' | 'or' }>>
  setSortModel: React.Dispatch<React.SetStateAction<{ field: string, sort: string }[]>>
  sortModel: { field: string, sort: string }[]
  loading: boolean
  selectedTab: number
}

export const NonPremiumEndorsementList: React.FC<Iprops> = ({
  ReportModuleCL,
  setSelectedRows,
  selectedRows,
  setCurrentPage,
  setPageSize,
  _pageSize,
  filterModel,
  setFilterModel,
  sortModel,
  setSortModel,
  loading,
  selectedTab,
}) => {
  const { user } = useAuth();
  const [error, setError] = useState<string | null>(null);
  const [dataLoaded, setDataLoaded] = React.useState(false);
  const [isLoading, setIsLoading] = useState(loading);
  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  const columns: GridColDef[] = [
    {
      field: "client", headerName: "Client", type: "string", headerAlign: "left", hideSortIcons: true, renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'client'
          );
    
        const isSortedAsc = sortItem?.sort === 'asc';
        const isSortedDesc = sortItem?.sort === 'desc'
        return (
          <div>
            <span className="table-card-title">{params.colDef.headerName}</span>
            {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
          </div>
        )
      },
      align: "left", flex: 3, minWidth: 100,
      valueGetter: (params) => params.row.client || params.row.customerName || "",
    },
    {
      field: "state", headerName: "State", type: "string", headerAlign: "left", hideSortIcons: true,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'state'
          );
    
        const isSortedAsc = sortItem?.sort === 'asc';
        const isSortedDesc = sortItem?.sort === 'desc'
        return (
          <div>
            <span className="table-card-title">{params.colDef.headerName}</span>
            {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
          </div>
        )
      },
      align: "left", flex: 2, minWidth: 70,
      valueGetter: (params) => params.row.state || params.row.filingState || params.row.homeState || "",
    },
    {
      field: "document", headerName: "Document", type: "string", headerAlign: "left", hideSortIcons: true, renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'document'
          );
    
        const isSortedAsc = sortItem?.sort === 'asc';
        const isSortedDesc = sortItem?.sort === 'desc'
        return (
          <div>
            <span className="table-card-title">{params.colDef.headerName}</span>
            {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
          </div>
        )
      },
      align: "left", flex: 3, minWidth: 200,
      renderCell: (params) => {
        const documentName = params.row.document || params.row.documentName || "";
        const blobAddress = params.row.blobAddress;
        
        if (blobAddress && documentName) {
          return (
            <a 
              href={blobAddress} 
              target="_blank" 
              rel="noopener noreferrer" 
              style={{ 
                display: 'block',
                width: '100%',
                textAlign: 'left',
                color: '#162E3C', 
                textDecoration: 'none', 
                overflow: 'initial', 
                whiteSpace: 'break-spaces',
                lineHeight: 'normal',
                wordBreak: 'break-word'
              }}
            >
              {documentName}
            </a>
          );
        }
        return (
          <Box sx={{ 
            width: '100%',
            textAlign: 'left',
            overflow: 'initial', 
            textOverflow: 'ellipsis', 
            whiteSpace: 'break-spaces',
            lineHeight: 'normal',
            wordBreak: 'break-word'
          }}>
            {documentName || "-"}
          </Box>
        );
      },
    },
    {
      field: "dateReceived", headerName: "Date Received", type: "date", headerAlign: "left", hideSortIcons: true, renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'dateReceived'
          );
    
        const isSortedAsc = sortItem?.sort === 'asc';
        const isSortedDesc = sortItem?.sort === 'desc'
        return (
        <div>
          <span className="table-card-title">{params.colDef.headerName}</span>
          {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
        </div>
      )
      }, align: "left", flex: 3, minWidth: 200,
      valueGetter: (params) => {
        const dateValue = params.row.dateReceived || params.row.dateRecived || "";
        return dateValue ? new Date(dateValue) : null;
      },
      renderCell: (params) => {
        if (!params.value) return "";
        const formatted = formatUtcToLocal(params.value, "MM/DD/YYYY");
        if (formatted === 'N/A') return "";
        const date = new Date(params.value);
        if (date.getFullYear() === 1900) return "";
        return formatted;
      },
    },
    {
      field: "dateCompleted", headerName: "Date Filed", type: "date", headerAlign: "left", hideSortIcons: true, renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'dateCompleted'
          );
    
        const isSortedAsc = sortItem?.sort === 'asc';
        const isSortedDesc = sortItem?.sort === 'desc'
        return (
        <div>
          <span className="table-card-title">{params.colDef.headerName}</span>
          {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
        </div>
      )
      }, align: "left", flex: 3, minWidth: 150,
      valueGetter: (params) => {
        const dateValue = params.row.dateCompleted || "";
        return dateValue ? new Date(dateValue) : null;
      },
      renderCell: (params) => {
        if (!params.value) return "";
        const formatted = formatUtcToLocal(params.value, "MM/DD/YYYY");
        if (formatted === 'N/A') return "";
        const date = new Date(params.value);
        if (date.getFullYear() === 1900) return "";
        return formatted;
      },
      hide: selectedTab !== 2,
    },
    ...(selectedTab === 3 ? ([
      {
        field: "rejectedAt",
        headerName: "Rejected Date",
        type: "date",
        headerAlign: "left",
        hideSortIcons: true,
        align: "left",
        flex: 2,
        minWidth: 150,
        valueGetter: (params) => {
          const dateValue = params.row.rejectedAt || "";
          return dateValue ? new Date(dateValue) : null;
        },
        renderCell: (params) => {
          if (!params.value) return "";
          const formatted = formatUtcToLocal(params.value, "MM/DD/YYYY");
          if (formatted === 'N/A') return "";
          return formatted;
        },
      },
      {
        field: "rejectionNote",
        headerName: "Rejection Note",
        type: "string",
        headerAlign: "left",
        align: "left",
        hideSortIcons: true,
        flex: 3,
        minWidth: 250,
        valueGetter: (params) => params.row.rejectionNote || "-",
        renderCell: (params) => {
          const note = params.row.rejectionNote || "-";
          return (
            <Tooltip title={note} arrow placement="top">
              <Typography
                component="span"
                sx={{
                  width: "100%",
                  textAlign: "left",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "block",
                }}
              >
                {note}
              </Typography>
            </Tooltip>
          );
        },
      },
    ] as GridColDef[]) : []),
  ];

  const sortModelRef = useRef<GridSortModel>([]);
  const onRowsSelectionHandler = (ids: GridSelectionModel | undefined) => {
    try {
      if (!ids || ids.length === 0) {
        setSelectedRows(null);
        return;
      }
      const selectedRows = ReportModuleCL.getNonPremiumEndorsement_Respdata.filter((row) => ids.includes(row.id ?? row.nonPremiumEndorsementId ?? 0));
      setSelectedRows(selectedRows);
    } catch (err) {
      console.error('Error in onRowsSelectionHandler:', err);
      setError('Error processing row selection');
    }
  };

  function EditToolbar() {
  return (
      <React.Fragment>
        <div style={{ position: "fixed", top: "0", left: "0", zIndex: "9990", width: "100%" }}>
          {loading && <LinearProgress color="info" sx={{ backgroundColor: "#132D3D" }} />}
        </div>
      </React.Fragment>
    )
  }

  useEffect(() => {
    if (ReportModuleCL?.getNonPremiumEndorsement_Respdata?.length > 0) {
        setDataLoaded(true);
    }
  }, [ReportModuleCL]);

  useEffect(() => {
      if (dataLoaded) {
          setIsLoading(false);
      }
  }, [dataLoaded]);
  
  return (
    <React.Fragment>
      <Box sx={{ height: "calc(100vh - 250px)", display: "flex", flexDirection: "column", width: "100%", backgroundColor: '#ffffff', position: 'relative' }}>
        {loading && (<>
          <Box
            position="absolute"
            top={0}
            left={0}
            right={0}
            bottom={0}
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{ backgroundColor: "rgba(250, 251, 252, 0.85)", zIndex: 10, border: "1px solid #e2e8f0", borderRadius: 1 }}
          >
            <Box sx={{ width: "100%", maxWidth: 320 }}>
              <LinearProgress color="info" sx={{ backgroundColor: "#e2e8f0", "& .MuiLinearProgress-bar": { backgroundColor: "#132D3D" } }} />
              <Box sx={{ mt: 1.5, textAlign: "center" }}>
                <span style={{ fontSize: "14px", fontWeight: 600, color: "#475569" }}>Loading...</span>
              </Box>
            </Box>
          </Box>
        </>)}
        <DataGridPro
          rowHeight={56}
          getRowId={(r) => r?.id || r?.nonPremiumEndorsementId}
          rows={ReportModuleCL.getNonPremiumEndorsement_Respdata}
          columns={columns}
          rowCount={ReportModuleCL.totalCount || 0}
          rowsPerPageOptions={getRowsPerPageOptions(ReportModuleCL?.totalCount, _pageSize)}
          pagination
          pageSize={_pageSize}
          paginationMode="server"
          onPageChange={(newPage: number) => setCurrentPage(newPage + 1)}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          filterMode="server"
          filterModel={filterModel}
          onFilterModelChange={(newFilterModel: any) => setFilterModel(newFilterModel)}
          sortingMode="server"
          sortingOrder={['asc', 'desc']}
          onSortModelChange={(newSortModel: any) => setSortModel(newSortModel)}
          sortModel={sortModel as GridSortModel}
          style={{ textAlign: "center" }}
          checkboxSelection={
            user?.userRoles.split(",").includes("Super Admin") ||
            user?.userRoles.split(",").includes("MISC State Reporter") ||
            user?.userRoles.split(",").includes("MISC Filer")
              ? true : false
          }
          onSelectionModelChange={
            user?.userRoles.split(",").includes("Super Admin") ||
            user?.userRoles.split(",").includes("MISC State Reporter") ||
            user?.userRoles.split(",").includes("MISC Filer")
              ? (newRowSelectionModel) => {
              onRowsSelectionHandler(newRowSelectionModel);
            } : undefined}
          selectionModel={selectedRows?.map((row) => row.id || row.nonPremiumEndorsementId).filter((id): id is number => id !== undefined) || []}
          components={{
            Toolbar: EditToolbar,
          }}
          loading={isLoading}
          sx={{
            fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
            border: "none",
            fontSize: "14px",
            color: "#475569",
            backgroundColor: "#ffffff",
            "& .MuiDataGridPro-columnHeaderTitle": {
              whiteSpace: "normal",
              lineHeight: 1.35,
              fontWeight: 600,
              fontSize: "12px",
              letterSpacing: "0.05em",
              textTransform: "uppercase",
              color: "#64748b",
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "#f8fafc",
              borderBottom: "2px solid #e2e8f0",
              borderTop: "2px solid #e2e8f0",
              minHeight: "52px !important",
              maxHeight: "52px !important",
            },
            "& .MuiDataGrid-columnHeader": {
              "&:focus, &:focus-within": { outline: "none" },
            },
            "& .MuiDataGrid-row": {
              transition: "background-color 0.15s ease",
              "&:nth-of-type(even)": {
                backgroundColor: "#fafbfc",
              },
              "&:hover": {
                backgroundColor: "#f1f5f9 !important",
              },
              "&.Mui-selected": {
                backgroundColor: "#ebf5fa !important",
                "&:hover": {
                  backgroundColor: "#dbeef7 !important",
                },
              },
            },
            "& .MuiDataGrid-cell": {
              borderBottom: "1px solid #f1f5f9",
              fontSize: "14px",
              color: "#334155",
              overflow: "visible",
              whiteSpace: "normal",
              lineHeight: "normal",
              wordWrap: "break-word",
              textOverflow: "clip",
              padding: "8px 16px",
              "&:focus": { outline: "none" },
            },
            '& .MuiDataGrid-cell[data-field="rejectionNote"], & .MuiDataGrid-columnHeader[data-field="rejectionNote"], & .MuiDataGrid-cell[data-field="document"], & .MuiDataGrid-columnHeader[data-field="document"]': {
              justifyContent: "flex-start",
              textAlign: "left",
            },
            ".custom-cell": {
              button: {
                padding: 0,
                width: '100%',
                height: '100%',
                textAlign: 'center',
                WebkitLineClamp: 2,
                lineClamp: 2,
                display: '-webkit-box',
                WebkitBoxOrient: 'vertical',
                textOverflow: 'ellipsis',
              }
            },
            "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows": {
              marginBottom: "0px !important",
            },
            ".MuiDataGrid-virtualScroller": {
              border: "none",
            },
            "& .MuiDataGrid-main": {
              border: "none",
            },
            "& .MuiDataGrid-footerContainer": {
              borderTop: "1px solid #e2e8f0",
              backgroundColor: "#f8fafc",
              minHeight: 56,
            },
            "& .MuiTablePagination-root": {
              color: "#64748b",
              fontSize: "13px",
            },
            "& .MuiTablePagination-select": {
              fontSize: "13px",
              borderRadius: "6px",
              border: "1px solid #e2e8f0",
            },
            "& .MuiIconButton-root": {
              color: "#64748b",
              "&:hover": {
                backgroundColor: "#f1f5f9",
                color: "#475569",
              },
            },
            "& .MuiCheckbox-root": {
              color: "#94a3b8",
              "&.Mui-checked": {
                color: "#2099d2",
              },
            },
          }}
          experimentalFeatures={{ newEditingApi: true }}
        />
      </Box>
    </React.Fragment>
  );
};

// Page Component
export const NonPremiumEndorsement: React.FC = () => {
  const { user } = useAuth();
  const token = user?.token;
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = React.useState(true);
  const [selectedTab, setSelectedTab] = useState(1);
  const [selectedClient, setSelectedClient] = useState(0);
  const [selectedHomeState, setSelectedHomeState] = useState(0);
  const [selectedRows, setSelectedRows] = useState<NonPremiumEndorsementModel[] | null>(null);
  const [rejectDialogOpen, setRejectDialogOpen] = useState(false);
  const [rejectionNote, setRejectionNote] = useState("");
  const [rejectSubmitting, setRejectSubmitting] = useState(false);
  // Pagination state
  const [_currentPage, setCurrentPage] = useState(1);
  const [_pageSize, setPageSize] = useState(50);
  
  // Filter and sort models
  const [filterModel, setFilterModel] = useState<{ items: { columnField: string, value: string, operatorValue: string }[], logicOperator?: 'and' | 'or' }>({ items: [], logicOperator: 'and' });
  const [sortModel, setSortModel] = useState<{ field: string, sort: string }[]>([]);
  
  // Data model
  const [reportModuleCL, setReportModuleCL] = useState<NonPremiumEndorsementModel_Resp>({
    getNonPremiumEndorsement_Respdata: [],
    totalCount: 0
  });
  
  // Filter data
  const [clients, setClients] = useState([{ partnersId: 0, customerName: "" }]);
  const [states, setStates] = useState([{ stateId: 0, stateName: "" }]);
  const isSuperAdmin = isSuperAdminRole(user?.userRoles);
  const canMarkComplete = canMarkMiscNonPremiumComplete(user?.userRoles);
  const clientData = React.useRef(0);
  const stateData = React.useRef(0);

  // Fetch clients data
  const fetchClients = () => {
    apiClient("/Partners/getPartners", {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      }),
    })
      .then((responseJson) => {
        if (!responseJson) return;
        setClients(responseJson.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // Fetch states data
  const fetchStates = () => {
    apiClient("/States/getStates", {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      }),
    })
      .then((responseJson) => {
        if (!responseJson) return;
        const allowedStates = ['California', 'Nevada', 'Pennsylvania', 'Washington', 'Texas'];
        const filteredStates = responseJson.data.filter((state: any) =>
            allowedStates.includes(state.stateName)
          );
        setStates(filteredStates);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // API request function
  const getNonPremiumEndorsement = async (pageSize: number, pageNumber: number) => {
    setLoading(true);
    
    try {
      const payload: any = {
        pageSize: pageSize,
        pageNumber: pageNumber,
        field: sortModel[0]?.field || '',
        sort: sortModel[0]?.sort || '',
        status: selectedTab === 1 ? 'Outstanding' : selectedTab === 2 ? 'Completed' : 'Rejected',
        filterModel: filterModel
      };
      
      if (clientData.current) payload.partnerId = clientData.current;
      if (stateData.current) payload.stateId = stateData.current;

      const response = await apiClient("/NonPremiumEndorsement/getNonPremiumEndorsement", {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }),
        body: JSON.stringify(payload),
      });

      if (response) {
        
        setReportModuleCL({
          getNonPremiumEndorsement_Respdata: response.data ,
          totalCount: response.totalCount || 0
        });
      }
    } catch (error) {
      console.error("Error fetching non-premium endorsements:", error);
    } finally {
      setLoading(false);
    }
  };

  // Separate function for fetching data that returns the response (for export)
  const fetchNonPremiumEndorsementData = async (pageSize: number, pageNumber: number) => {
    try {
      const payload: any = {
        pageSize: pageSize,
        pageNumber: pageNumber,
        field: sortModel[0]?.field || '',
        sort: sortModel[0]?.sort || '',
        status: selectedTab === 1 ? 'Outstanding' : selectedTab === 2 ? 'Completed' : 'Rejected',
        filterModel: filterModel
      };
      
      if (clientData.current) payload.partnerId = clientData.current;
      if (stateData.current) payload.stateId = stateData.current;

      const response = await apiClient("/NonPremiumEndorsement/getNonPremiumEndorsement", {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }),
        body: JSON.stringify(payload),
      });

      return response;
    } catch (error) {
      console.error("Error fetching non-premium endorsements:", error);
      throw error;
    }
  };

  useEffect(() => {
    let value = 1; 
    if (params.LastTabId === 'Completed') {
      value = 2;
    } else if (params.LastTabId === 'Rejected') {
      value = 3;
    }
    setSelectedTab(value);
    fetchClients();
    fetchStates();
    getNonPremiumEndorsement(_pageSize, _currentPage);
  }, []);

  useEffect(() => {
    getNonPremiumEndorsement(_pageSize, _currentPage);
  }, [selectedTab, _currentPage, _pageSize, sortModel, filterModel]);

  const handleSearch = () => {
    setCurrentPage(1);
    getNonPremiumEndorsement(_pageSize, 1);
  };

  const handleClear = () => {
    setSelectedClient(0);
    setSelectedHomeState(0);
    clientData.current = 0;
    stateData.current = 0;
    setFilterModel({ items: [] });
    setCurrentPage(1);
    getNonPremiumEndorsement(_pageSize, 1);
  };

  const handleMarkComplete = async () => {
    setLoading(true);
    
    try {
      const nonPremiumEndorsementIds = selectedRows?.map(row =>row.nonPremiumEndorsementId).filter(id => id !== undefined);

      const payload = {
        nonPremiumEndorsementIds: nonPremiumEndorsementIds,
        filterModel: filterModel
      };

      const response = await apiClient("/NonPremiumEndorsement/updateNonPremiumEndorsementStatus", {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }),
        body: JSON.stringify(payload),
      });

      if (response && response.status === true ) {
        setSelectedRows(null);
        getNonPremiumEndorsement(_pageSize, _currentPage);
      } else {
        alert(response?.message || "Failed to mark NonPremiumEndorsements as complete.");
      }
    } catch (error) {
      console.error("Error marking NonPremiumEndorsements as complete:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = async () => {
    // If no rows selected, download all data (similar to Export behavior)
    if (!selectedRows || selectedRows.length === 0) {
      // For consistency with Export, we could download all data here too
      // But keeping the current behavior for now since Download is typically for files
      alert("Please select at least one row to download.");
      return;
    }

    if (selectedRows.length === 1) {
      const selectedFile = selectedRows[0];
      
      // For single row, try direct download from blobAddress first
      if (selectedFile.blobAddress) {
        try {
          // Try fetch-based download first (more reliable)
          const response = await fetch(selectedFile.blobAddress);
          if (response.ok) {
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = selectedFile.document || selectedFile.documentName || 'NonPremiumEndorsement';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            
            console.log("Downloaded file via fetch from blob address:", selectedFile.blobAddress);
            return;
          }
        } catch (error) {
          console.warn("Fetch download failed, trying direct link:", error);
        }
        
        try {
          // Fallback: Direct download from blob address
          const link = document.createElement('a');
          link.href = selectedFile.blobAddress;
          link.download = selectedFile.document || selectedFile.documentName || 'NonPremiumEndorsement';
          link.target = '_blank';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          
          console.log("Downloaded file directly from blob address:", selectedFile.blobAddress);
          return;
        } catch (error) {
          console.warn("Direct download failed, falling back to ZIP generation:", error);
          // Fall through to ZIP generation if direct download fails
        }
      }
    }

    setLoading(true);
    
    try {
      // Extract file information from selected rows
      const selectedFiles = selectedRows.map(row => ({
        id: row.nonPremiumEndorsementId || row.id,
        document: row.document || row.documentName || "",
        fileName: row.document || row.documentName || `file_${row.nonPremiumEndorsementId || row.id}`,
        blobAddress: row.blobAddress
      })).filter(file => file.id !== undefined);

      if (selectedFiles.length === 0) {
        alert("No valid files found in selected rows.");
        return;
      }

      // Always use ZIP generation for both single and multiple files
      await downloadFilesAsZip(selectedFiles);

    } catch (error) {
      console.error("Error downloading files:", error);
      alert("An error occurred while downloading files. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleOpenBulkRejectDialog = () => {
    if (!selectedRows?.length) return;
    setRejectionNote("");
    setRejectDialogOpen(true);
  };

  const handleCloseRejectDialog = () => {
    if (rejectSubmitting) return;
    setRejectDialogOpen(false);
    setRejectionNote("");
  };

  const handleSubmitRejection = async () => {
    const nonPremiumEndorsementIds = selectedRows
      ?.map((row) => row.nonPremiumEndorsementId)
      .filter((id): id is number => id !== undefined && id > 0) ?? [];
    if (!nonPremiumEndorsementIds.length) return;

    const trimmedNote = rejectionNote.trim();
    if (!trimmedNote) return;

    setRejectSubmitting(true);
    try {
      const payload = {
        nonPremiumEndorsementIds,
        rejectionNote: trimmedNote,
      };

      const response = await apiClient("/NonPremiumEndorsement/rejectAndReturn", {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }),
        body: JSON.stringify(payload),
      });

      if (response?.status === true) {
        handleCloseRejectDialog();
        setSelectedRows(null);
        getNonPremiumEndorsement(_pageSize, _currentPage);
        Swal.fire({
          title: "Rejected",
          text: response?.message || "Non-premium endorsement rejected and returned to client.",
          icon: "success",
          confirmButtonText: "OK",
        });
      } else {
        Swal.fire({
          title: "Unable to Reject",
          text: response?.message || "Failed to reject non-premium endorsement.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("Error rejecting non-premium endorsement:", error);
      const errorMessage = error instanceof Error ? error.message : "An error occurred while rejecting the non-premium endorsement.";
      Swal.fire({
        title: "Error",
        text: errorMessage,
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setRejectSubmitting(false);
    }
  };

  const downloadFilesAsZip = async (files: { id: number | undefined; document: string; fileName: string }[]) => {
    try {
      const fileIds = files.map(file => file.id).filter(id => id !== undefined).join(",");

      if (!fileIds) {
        alert("No valid file IDs found for download.");
        return;
      }

      // Show loading dialog
      Swal.fire({
        title: 'Generating Download...',
        text: 'Please wait while we generate your download package.',
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      // Build comprehensive request payload similar to month end billing
      const requestPayload = {
        // Core context 
        fileIds: fileIds,
        userId: user?.userId,
        userTimezone: 'America/Denver',
        status: selectedTab === 1 ? 'Outstanding' : selectedTab === 2 ? 'Completed' : 'Rejected',
        
        // Filter context
        clientFilter: selectedClient || "",
        stateFilter: selectedHomeState || "",
        
        // Include all selected files
        includeFiles: {
          outstanding: selectedTab === 1,
          completed: selectedTab === 2,
          rejected: selectedTab === 3,
          allSelected: true,
          NonPremiumEndorsement: true
        }
      };

      // Single API call to generate comprehensive ZIP download
      const response = await apiClient('/NonPremiumEndorsement/generate-comprehensive-non-premium-endorsement-zip', {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }),
        body: JSON.stringify(requestPayload)
      });

      setLoading(false);
      Swal.close();

      if (!response) {
        throw new Error('No response received from server');
      }

      // Check for error indicators based on actual response structure
      const hasError = response.status === false || response.resp !== 0 || response.error
        || (response.message && response.message.toLowerCase().includes('error'))
        || (response.message && response.message.toLowerCase().includes('unavailable'))
        || (response.message && response.message.toLowerCase().includes('no non-premium'));
      
      if (hasError) {
        throw new Error(response?.message || response?.error || 'Failed to generate ZIP download');
      }

      // Handle the response based on actual backend structure - same as month end billing
      if (response.data?.zip_url) {
        // Direct download of the ZIP file
        window.open(response.data.zip_url, "_blank");
        console.log("Opened ZIP file download URL:", response.data.zip_url);
        
      } else if (response.data?.zipBase64) {
        // Convert base64 to blob and download
        const byteCharacters = atob(response.data.zipBase64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/zip' });
        
        const fileName = `NonPremiumEndorsements_${new Date().toISOString().split('T')[0]}.zip`;
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        
        console.log(`Downloaded ZIP file, Size: ${blob.size} bytes`);
        
      } else if (response.data?.downloadUrl) {
        // Direct URL download
        window.open(response.data.downloadUrl, "_blank");
        console.log("Opened download URL:", response.data.downloadUrl);
        
      } else if (response.zipBase64) {
        // Maybe the ZIP data is at the root level
        const byteCharacters = atob(response.zipBase64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/zip' });
        
        const fileName = `NonPremiumEndorsements_${new Date().toISOString().split('T')[0]}.zip`;
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        
        console.log(`Downloaded ZIP file, Size: ${blob.size} bytes`);
        
      } else {
        // Show a message about the response structure
        Swal.fire({
          title: "Response Received",
          text: `Server responded but no ZIP download data found. Message: ${response?.message || 'No message'}`,
          icon: "warning",
          confirmButtonText: "OK",
        });
        return; // Exit early since we can't process the download
      }

      // Show success message with summary
      let summaryText = response?.message || "Your Non Premium Endorsement ZIP download has been generated successfully.";
      
      // Add summary information if available
      if (response.data?.files_count) {
        summaryText += `\n\n📊 ZIP Download Summary:`;
        summaryText += `\n• Total Files Downloaded: ${response.data.files_count}`;
        summaryText += `\n• ZIP Filename: ${response.data.zip_filename || 'NonPremiumEndorsements.zip'}`;
      }

      Swal.fire({
        title: "ZIP Generated Successfully!",
        text: summaryText,
        icon: "success",
        confirmButtonText: "OK",
      });

    } catch (error) {
      console.error("Error downloading ZIP file:", error);
      
      Swal.fire({
        title: "ZIP Download Failed",
        text: error instanceof Error ? error.message : "Failed to download ZIP file. Please try again.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };
  
  const handleExportPdf = async () => {
    try {
      setLoading(true);
      
      // Show loading dialog
      Swal.fire({
        title: 'Generating PDF...',
        text: 'Please wait while we generate your PDF report.',
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      // Prepare request payload - matching getNonPremiumEndorsement API structure
      const requestPayload: any = {
        pageSize: reportModuleCL.totalCount || 1000,
        pageNumber: 1,
        field: sortModel[0]?.field || '',
        sort: sortModel[0]?.sort || '',
        status: selectedTab === 1 ? 'Outstanding' : selectedTab === 2 ? 'Completed' : 'Rejected',
        filterModel: filterModel,
        userTimezone: 'America/Denver'
      };
      
      // Add optional filters
      if (clientData.current) requestPayload.partnerId = clientData.current;
      if (stateData.current) requestPayload.stateId = stateData.current;
      
      // Add nonPremiumEndorsementIds if rows are selected
      if (selectedRows && selectedRows.length > 0) {
        requestPayload.nonPremiumEndorsementIds = selectedRows
          .map(row => row.nonPremiumEndorsementId || row.id)
          .filter(id => id !== undefined);
      }

      // Call the PDF generation API
      const responseJson = await apiClient('/NonPremiumEndorsement/get-non-premium-endorsement-pdf', {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }),
        body: JSON.stringify(requestPayload),
      });

      setLoading(false);
      Swal.close();

      if (!responseJson) {
        Swal.fire({
          title: 'Error!',
          text: 'Failed to get response from server.',
          icon: 'error',
          confirmButtonColor: '#02A4E3'
        });
        return;
      }
      const pdfUrl = responseJson.data?.pdf_url || responseJson.data?.pdfUrl;

      // Handle server-side PDF generation response
      if (responseJson.status && responseJson.data && pdfUrl) {
        // Download PDF from the provided URL
        const link = document.createElement('a');
        link.href = pdfUrl;
        link.download = responseJson.data.filename || 'non-premium-endorsement-report.pdf';
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Show success message
        Swal.fire({
          title: 'Success!',
          text: `PDF downloaded successfully!`,
          icon: 'success',
          confirmButtonColor: '#02A4E3',
          timer: 3000,
          timerProgressBar: true
        });
        return;
      } else {
        Swal.fire({
          title: 'Error!',
          text: responseJson.message || 'Failed to generate PDF. Please try again.',
          icon: 'error',
          confirmButtonColor: '#02A4E3'
        });
        return;
      }
    } catch (error) {
      setLoading(false);
      Swal.close();
      
      Swal.fire({
        title: 'Error!',
        text: 'An error occurred while generating the PDF. Please try again.',
        icon: 'error',
        confirmButtonColor: '#02A4E3'
      });
      return;
    }
  };

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setIsLoading(true);
    setSelectedTab(newValue);
  };

  return (
    <Box>
      {/* <div className="d-flex align-items-center justify-content-between mb-2">
        <div className="card-title">
          <span className="d-flex">Non Premium Endorsement</span>
        </div>
      </div> */}
      <div style={{ position: "fixed", top: "0", left: "0", zIndex: "9990", width: "100%" }}>
        {loading && <LinearProgress color="info" sx={{ backgroundColor: "#132D3D" }} />}
      </div>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: { xs: "flex-start", lg: "center" },
          flexDirection: { xs: "column", lg: "row" },
          gap: 1.5,
          px: { xs: 0, lg: 2 },
          py: { xs: 0, lg: 1.5 },
          mb: { xs: 1, lg: 3 },
          borderBottom: { xs: "none", lg: "1px solid #e2e8f0" },
          backgroundColor: { xs: "transparent", lg: "#fafbfc" },
          minHeight: 56,
          marginLeft: { xs: '-24px', md: '0px' },
          marginRight: { xs: '-24px', md: '0px' },
        }}
      >
        {/* Tabs: desktop only (md and up) */}
        <Tabs
          value={selectedTab}
          onChange={handleTabChange}
          aria-label="Non Premium Endorsement Tabs"
          sx={{
            // display: { xs: "none", md: "flex" },
            minHeight: 48,
            padding: { xs: "20px", lg: "0px" },
            width: { xs: "100%", lg: "auto" },
            borderBottom: { xs: "1px solid #e2e8f0", lg: "none" },
            backgroundColor: { xs: "#fafbfc", lg: "transparent" },
            "& .MuiTab-root": { textTransform: "none", fontWeight: 600, fontSize: "0.9375rem" },
            "& .Mui-selected": { color: "#2099d2" },
            "& .MuiTabs-indicator": { backgroundColor: "#2099d2", height: 3, borderRadius: "3px 3px 0 0" },
          }}
        >
          <Tab label="Outstanding" value={1} />
          <Tab label="Completed" value={2} />
          <Tab label="Rejected" value={3} />
        </Tabs>
        {/* Select option for mobile/tablet view */}
        {/* <FormControl
          size="small"
          sx={{
            display: { xs: "block", md: "none" },
            width: "100%",
            padding: { xs: "20px", lg: "0px" },
            backgroundColor: { xs: "#fafbfc", lg: "transparent" },
            borderBottom: { xs: "1px solid #e2e8f0", lg: "none" },
            minWidth: 160,
            "& .MuiOutlinedInput-notchedOutline": { borderColor: "#e2e8f0" },
            "& .MuiSelect-select": { fontWeight: 600, color: "#2099d2", py: 0.9 },
          }}
        >
          <Select
            value={selectedTab}
            onChange={(e) => handleTabChange(undefined as any, Number(e.target.value))}
            displayEmpty
            sx={{ textTransform: "none", fontSize: "0.9375rem" }}
          >
            <MenuItem value={1}>Outstanding</MenuItem>
            <MenuItem value={2}>Completed</MenuItem>
          </Select>
        </FormControl> */}
        <Box className="filter-grid" sx={{ display: "flex", gap: 1, width: { xs: "100%", lg: "calc(100% - 250px)" }, px: { sm: 4, md: 0 } }}>
          <Grid container spacing={2} sx={{ px: { xs: 4, sm: 0 } }} justifyContent={{ xs: "flex-start", lg: "flex-end" }}>
            <Grid item xl={2} lg={3} sm={3} xs={12}>
              <Autocomplete
                sx={{
                  marginTop: "-4px !important",
                  "& .MuiAutocomplete-input": {
                    padding: "0px 4px 0px 5px !important",
                  },
                }}
                options={clients}
                getOptionLabel={(option) => option.customerName}
                onChange={(event, value) => {
                  setSelectedClient(value?.partnersId ?? 0);
                  clientData.current = value?.partnersId ?? 0;
                }}
                value={clients.find(item => item.partnersId === selectedClient)}
                renderInput={(params) => (
                  <TextField
                    sx={{
                      ".MuiFormLabel-root.Mui-focused": {
                        color: (typeof params.inputProps.value === "string" && params.inputProps.value.length > 0) ? "#000" : "#cccccc !important"
                      },
                      '& .MuiInputBase-root': { marginTop: '5px !important' },
                      '& .MuiOutlinedInput-root': { padding: '4.5px 9px' },
                      '& .MuiFormLabel-root': { transform: 'translate(14px, 13px) scale(1)' },
                      '& .MuiInputLabel-shrink': { transform: 'translate(14px, -2px) scale(0.75)' },
                    }}
                    {...params}
                    label="Client"
                    InputLabelProps={{ ...params.InputLabelProps, shrink: (selectedClient > 0 || (typeof params.inputProps.value === "string" && params.inputProps.value.length > 0)) ? true : false }}
                  />
                )}
              />
            </Grid>
            <Grid item xl={2} lg={3} sm={3} xs={12}>
              <Autocomplete
                sx={{
                  marginTop: "-4px !important",
                  "& .MuiAutocomplete-input": {
                    padding: "0px 4px 0px 5px !important",
                  },
                }}
                options={states}
                getOptionLabel={(option) => option.stateName}
                onChange={(event, value) => {
                  setSelectedHomeState(value?.stateId ?? 0);
                  stateData.current = value?.stateId ?? 0;
                }}
                value={states.find(item => item.stateId === selectedHomeState)}
                renderInput={(params) => (
                  <TextField
                    sx={{
                      ".MuiFormLabel-root.Mui-focused": {
                        color: (typeof params.inputProps.value === "string" && params.inputProps.value.length > 0) ? "#000" : "#cccccc !important"
                      },
                      '& .MuiInputBase-root': { marginTop: '5px !important' },
                      '& .MuiOutlinedInput-root': { padding: '4.5px 9px' },
                      '& .MuiFormLabel-root': { transform: 'translate(14px, 13px) scale(1)' },
                      '& .MuiInputLabel-shrink': { transform: 'translate(14px, -2px) scale(0.75)' },
                    }}
                    {...params}
                    label="Home State"
                    InputLabelProps={{ ...params.InputLabelProps, shrink: (selectedHomeState > 0 || (typeof params.inputProps.value === "string" && params.inputProps.value.length > 0)) ? true : false }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm="auto" md="auto">
              <Box sx={{ display: "flex", gap: 1, justifyContent: { xs: "center", md: "flex-end" } }}>
                <Button
                  variant="contained"
                  size="medium"
                  onClick={() => { handleSearch(); }}
                  startIcon={<Search />}
                  sx={{
                    textTransform: "none",
                    fontWeight: 600,
                    backgroundColor: "#2099d2",
                    "&:hover": { backgroundColor: "#176990" },
                  }}
                >
                  Search
                </Button>
                <Button
                  variant="outlined"
                  size="medium"
                  onClick={() => { handleClear(); }}
                  startIcon={<Close />}
                  sx={{
                    textTransform: "none",
                    fontWeight: 600,
                    borderColor: "#e2e8f0",
                    color: "#475569",
                    "&:hover": { borderColor: "#2099d2", color: "#2099d2" },
                  }}
                >
                  Clear
                </Button>
                <Button
                  variant="outlined"
                  size="medium"
                  onClick={() => window.location.reload()}
                  startIcon={<Refresh />}
                  sx={{
                    textTransform: "none",
                    fontWeight: 600,
                    borderColor: "#e2e8f0",
                    color: "#475569",
                    "&:hover": {
                      borderColor: "#2099d2",
                      backgroundColor: "#2099d214",
                      color: "#2099d2",
                    },
                  }}
                >
                  Refresh
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>

      
      <Box sx={{ height: "calc(100vh - 250px)", display: "flex", flexDirection: "column", width: "100%", borderRadius: '12px', overflow: 'hidden', boxShadow: '0 4px 24px rgba(15, 23, 42, 0.08), 0 1px 3px rgba(15, 23, 42, 0.06)', border: '1px solid #e2e8f0', backgroundColor: '#ffffff' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap', px: 1.5 }}>
          <Typography variant="subtitle1" fontWeight={600} sx={{ color: '#334155', mr: 'auto', pl: 1, py: 2 }}>{selectedTab === 1 ? "Outstanding" : selectedTab === 2 ? "Completed" : "Rejected"} Non Premium Endorsement</Typography>
          {selectedRows && selectedRows.length > 0 && selectedTab === 1 && isSuperAdmin && (
            <Button
              variant="outlined"
              size="small"
              color="error"
              onClick={handleOpenBulkRejectDialog}
              sx={{ textTransform: "none", fontWeight: 600 }}
            >
              Reject & Return
            </Button>
          )}
          {selectedRows && selectedRows.length > 0 && selectedTab === 1 && canMarkComplete && (
            <Button
              variant="contained"
              size="small"
              onClick={handleMarkComplete}
              sx={{ textTransform: "none", fontWeight: 600, backgroundColor: "#dc2626", "&:hover": { backgroundColor: "#b91c1c" } }}
            >
              Mark Complete
            </Button>
          )}
          {selectedRows && selectedRows.length > 0 && (
            <Button
              variant="contained"
              size="small"
              onClick={() => { handleDownload() }}
              startIcon={<FileDownload />}
              sx={{ textTransform: "none", fontWeight: 600, backgroundColor: "#2099d2", "&:hover": { backgroundColor: "#4f46e5" } }}
            >
              Download
            </Button>
          )}
          <Button
            variant="contained"
            size="small"
            onClick={() => { handleExportPdf() }}
            startIcon={<FileDownload />}
            sx={{ textTransform: "none", fontWeight: 600, backgroundColor: "#2099d2", "&:hover": { backgroundColor: "#176990" } }}
          >
            Export
          </Button>
        </Box>
        {/* Data Grid */}
        <NonPremiumEndorsementList
            ReportModuleCL={reportModuleCL}
            setSelectedRows={setSelectedRows}
            selectedRows={selectedRows}
            setCurrentPage={setCurrentPage}
            setPageSize={setPageSize}
            _pageSize={_pageSize}
            filterModel={filterModel}
            setFilterModel={setFilterModel}
            setSortModel={setSortModel}
            sortModel={sortModel}
            loading={loading}
            selectedTab={selectedTab}
        />
      </Box>
      <Dialog open={rejectDialogOpen} onClose={handleCloseRejectDialog} maxWidth="sm" fullWidth>
        <DialogTitle>Reject & Return</DialogTitle>
        <DialogContent>
          <Typography sx={{ mb: 1.5, color: "#475569" }}>
            {selectedRows && selectedRows.length > 1
              ? `Enter a note to explain why these ${selectedRows.length} non-premium endorsements cannot be processed. The same note will be sent to each client.`
              : "Enter a note to explain why this non-premium endorsement cannot be processed."}
          </Typography>
          <TextField
            fullWidth
            multiline
            minRows={4}
            autoFocus
            value={rejectionNote}
            onChange={(event) => setRejectionNote(event.target.value)}
            placeholder="Reason is required"
            inputProps={{ maxLength: REJECTION_NOTE_MAX_LENGTH }}
            helperText={`${rejectionNote.length}/${REJECTION_NOTE_MAX_LENGTH} characters`}
          />
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={handleCloseRejectDialog} disabled={rejectSubmitting}>
            Cancel
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={handleSubmitRejection}
            disabled={
              rejectSubmitting
              || rejectionNote.trim().length === 0
              || rejectionNote.length > REJECTION_NOTE_MAX_LENGTH
            }
            sx={{ textTransform: "none", fontWeight: 600 }}
          >
            Submit Reject & Return
          </Button>
        </DialogActions>
      </Dialog>
   </Box>
 );
};

export default NonPremiumEndorsement;